import React, { Component } from 'react'
import IssuesModel from '../models/IssuesModel'
import { Row, Col, Button, Icon, Steps, Form, message } from 'antd'
import IssueStep1 from './IssueStep1'
import IssueStep2 from './IssueStep2'
import IssueStep3 from './IssueStep3'
import IssueStep4 from './IssueStep4'
import LoadingComponent from './Loading'
import config from 'react-observable-store'

const Step = Steps.Step

class PublicForm extends Component {

    constructor(props) {
        super(props)
        this.initValidation = this.initValidation.bind(this)
        this.onChangeField = this.onChangeField.bind(this)
        this.onChangeMiti = this.onChangeMiti.bind(this)
        this.onChangeMitiItem = this.onChangeMitiItem.bind(this)
        this.onChangeCons = this.onChangeCons.bind(this)
        this.onChangeConsItem = this.onChangeConsItem.bind(this)
        this.changeStep = this.changeStep.bind(this)
        this.onStepBackward = this.onStepBackward.bind(this)
        this.onStepForward = this.onStepForward.bind(this)
        this.onUploadAttach = this.onUploadAttach.bind(this)
        this.onRemoveAttach = this.onRemoveAttach.bind(this)
        this.onRemoveTempAttach = this.onRemoveTempAttach.bind(this)
        this.onSaveForm = this.onSaveForm.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.loading = this.loading.bind(this)

        // Init map
        this.map = IssuesModel.createMap(config.get('globals').olmap1, props.data.mapCenter, props.data.mapZoom)

        // Register events
        this.map.on('moveend', () => {
            this.props.changeMapCenter(
                this.map.getView().getCenter(),
                this.map.getView().getZoom()
            )
        })

        // Init UI form state
        this.state = {
            ...this.props.data,
            loading: false,
            praias: [],
            newAttach: [],
            user: this.props.data.id ? this.props.data.tecnico
                : (this.props.auth.username ? this.props.auth.username : IssuesModel.generateAnonymousId()),
            entidade: this.props.data.id ? this.props.data.entidade
                : (this.props.auth.entidade ? this.props.auth.entidade : ''),
            v: this.initValidation()
        }
    }

    loading(toggle = true) {
        var state = Object.assign({}, this.state)
        state.loading = toggle
        this.setState(state)
    }

    initValidation() {
        return {
            show: false,
            freguesia: {rule: 'required', msg: ''},
            tipo: {rule: 'required', msg: ''}
        }
    }

    componentWillReceiveProps(nextProps) {
        var formData = {
            ...this.state,
            id: nextProps.data.id ? nextProps.data.id : this.state.id,
            data_registo: nextProps.data.data_registo ? nextProps.data.data_registo : this.state.data_registo,
            mapCenter: nextProps.data.mapCenter,
            mapZoom: nextProps.data.mapZoom,
            dicofre: nextProps.caop ? nextProps.caop.dicofre || '' : this.state.dicofre,
            freguesia: nextProps.caop ? nextProps.caop.freguesia || '' : this.state.freguesia,
            concelho: nextProps.caop ? nextProps.caop.concelho || '' : this.state.concelho,
            distrito: nextProps.caop ? nextProps.caop.distrito || '' : this.state.distrito,
            arh_cod: nextProps.caop ? nextProps.caop.arh_cod || '' : this.state.arh_cod,
            arh: nextProps.caop ? nextProps.caop.arh || '' : this.state.arh,
            praias: nextProps.caop && nextProps.caop.praias ? nextProps.caop.praias : this.state.praias,
            attachments: nextProps.data.attachments,
            submitdate: nextProps.data.submitdate,
            status: nextProps.data.status,
            loading: false
        }
        this.setState(formData)
    }

    changeStep(step) {

        // Validate step number
        if (step < 0 || step > 3) return

        // TODO: validate step change
        var formData = {
            ...this.state
        }
        var result = true
        formData.v.show = false

        if (step === 1) {
            if (formData.v.title && (formData.v.title.rule === 'required') && (formData.title.length === 0)) {
                formData.v.title.msg = 'O campo título é obrigatório'
                result = false
            }
        }
        if (step === 2) {
            if (formData.v.freguesia && (formData.v.freguesia.rule === 'required') && (formData.freguesia.length === 0)) {
                formData.v.freguesia.msg = 'A localização não é válida'
                result = false
            }
            if (
                (typeof formData.mapCenter === 'undefined') || (formData.mapCenter === null)
                || (typeof formData.mapCenter[0] === 'undefined') || (formData.mapCenter[0] === null)
                || (typeof formData.mapCenter[1] === 'undefined') || (formData.mapCenter[1] === null)
            ) {
                formData.v.freguesia.msg = 'A localização não é válida'
                result = false
            }
            if (!formData.type_a && !formData.type_b && !formData.type_c && !formData.type_d) {
                formData.v.tipo.msg = 'A tipologia é obrigatória'
                result = false
            }
        }

        // Return on invalid change
        if (!result) {
            formData.v.show = true
            message.error(`Por favor corrija os campos inválidos.`)
            return this.setState(formData)
        }

        // Change step
        this.props.changeStep(step)
    }

    onStepBackward() {
        const nextStep = this.props.step - 1
        this.changeStep(nextStep)
    }

    onStepForward() {
        const nextStep = this.props.step + 1
        this.changeStep(nextStep)
    }

    onChangeField(field, value) {
        const formData = Object.assign({}, this.state)
        formData[field] = value
        this.setState(formData)
    }

    onChangeMitiItem(field, value) {
        const formData = Object.assign({}, this.state)
        formData[field] = value
        formData['miti'] = value ? '3' : formData['miti']
        if (!formData['miti_c_i'] && !formData['miti_c_ii'] && !formData['miti_c_iii'] && !formData['miti_c_iv'] && !formData['miti_c_v']) {
            formData['miti'] = '1'
        }
        this.setState(formData)
    }

    onChangeMiti(value) {
        const formData = Object.assign({}, this.state)
        formData['miti'] = value
        if (value !== '3') {
            formData['miti_c_i'] = null
            formData['miti_c_ii'] = null
            formData['miti_c_iii'] = null
            formData['miti_c_iv'] = null
            formData['miti_c_v'] = null
        }
        this.setState(formData)
    }

    onChangeCons(value) {
        const formData = Object.assign({}, this.state)
        formData['cons_bi'] = value
        if (value) {
            formData['cons_bii'] = false
            formData['cons_bii1'] = false
            formData['cons_bii2'] = false
            formData['cons_bii3'] = false
            formData['cons_biii'] = false
            formData['cons_biv'] = false
            formData['cons_bv'] = false
        }
        this.setState(formData)
    }

    onChangeConsItem(field, value) {
        const formData = Object.assign({}, this.state)
        formData[field] = value
        formData['cons_bi'] = value ? false : formData['cons_bi']
        if ((field === 'cons_bii') && !value) {
            formData['cons_bii1'] = false
            formData['cons_bii2'] = false
            formData['cons_bii3'] = false
        }
        if (!formData['cons_bii'] && !formData['cons_biii'] && !formData['cons_biv'] && !formData['cons_bv']) {
            formData['cons_bi'] = true
        }
        this.setState(formData)
    }

    onSaveForm() {
        const formData = Object.assign({}, this.state)
        formData['status'] = formData['status'] ? formData['status'] : 'Guardada';
        formData['step'] = this.props.step
        this.props.storeForm(formData)
        formData['loading'] = true
        this.setState(formData)
    }

    onSubmit() {
        const formData = Object.assign({}, this.state)
        formData['status'] = 'Submetida'
        formData['step'] = this.props.step
        this.props.submitForm(formData)
        formData['loading'] = true
        this.setState(formData)
    }

    onRemoveAttach(item) {
        this.props.removeAttach(item)
        const formData = Object.assign({}, this.state)
        formData.attachments = formData.attachments.filter((attach) => {
            return attach.id === item.id ? false : true
        })
        this.setState(formData)
    }

    onRemoveTempAttach(filename) {
        var attach = false
        this.state.newAttach.forEach((item) => {
            if (filename === item.name) attach = item
        })
        this.props.removeTempAttach(attach)
        const formData = Object.assign({}, this.state)
        formData.newAttach = formData.newAttach.filter((item) => {
            return filename === item.name ? false : true
        })
        this.setState(formData)
    }

    onUploadAttach(item) {
        const formData = Object.assign({}, this.state)
        formData.newAttach.push(item)
        this.setState(formData)
    }

    render() {
        const stepClassName = (step) => {
            return this.props.step === step ? "visible" : "hidden"
        }
        if (this.state.loading) return (<LoadingComponent />)
        return (
            <div>
                <Form onSubmit={this.props.handleSubmit}>
                    <Row>
                        <Col span={16}>
                            <Steps current={this.props.step}>
                                <Step title="Identificação" description="Identificação da ocorrência" />
                                <Step title="Detalhes" description="Detalhes da ocorrência" />
                                <Step title="Anexos" description="Anexos da ocorrência" />
                                <Step title="Concluído" description="Resultado da submissão" />
                            </Steps>
                        </Col>
                        <Col className="issueStepControl" span={8}>
                            <Button.Group>
                                { this.props.step > 0 ? (
                                    <Button type="primary" onClick={this.onStepBackward}>
                                        <Icon type="left" /><span className="hide-small">Anterior</span>
                                    </Button>
                                ) : null }
                                { this.props.step <= 2 ? (
                                    <Button type="primary" onClick={this.onStepForward}>
                                        <span className="hide-small">Seguinte</span><Icon type="right" />
                                    </Button>
                                ) : null }
                            </Button.Group>
                        </Col>
                    </Row>
                    <Row style={{marginTop: '24px'}}>
                        <Col span={24}>
                            <IssueStep1 {...this.state}
                                className={stepClassName(0)}
                                onChangeField={this.onChangeField}
                            />
                            <IssueStep2 {...this.state}
                                className={stepClassName(1)}
                                map={this.map}
                                gmapsGeocoder={this.props.gmapsGeocoder}
                                changeMapCenter={this.props.changeMapCenter}
                                onChangeField={this.onChangeField}
                                onChangeMiti={this.onChangeMiti}
                                onChangeMitiItem={this.onChangeMitiItem}
                                onChangeCons={this.onChangeCons}
                                onChangeConsItem={this.onChangeConsItem}
                                getDeviceGeolocation={this.props.getDeviceGeolocation}
                            />
                            <IssueStep3 {...this.state}
                                className={stepClassName(2)}
                                onChangeField={this.onChangeField}
                                onUploadAttach={this.onUploadAttach}
                                onRemoveAttach={this.onRemoveAttach}
                                onRemoveTempAttach={this.onRemoveTempAttach}
                            />
                            <IssueStep4 {...this.state}
                                loading={this.loading}
                                complete={this.props.complete}
                                error={this.props.error}
                                className={stepClassName(3)}
                                onChangeField={this.onChangeField}
                                onSaveForm={this.onSaveForm}
                                onSubmit={this.onSubmit}
                                resetForm={this.props.resetForm}
                                history={this.props.history}
                            />
                        </Col>
                    </Row>
                    <Row style={{margin: '24px auto'}}>
                        <Col span={16}>
                            <Steps current={this.props.step}>
                                <Step title="Identificação" description="Identificação da ocorrência" />
                                <Step title="Detalhes" description="Detalhes da ocorrência" />
                                <Step title="Anexos" description="Anexos da ocorrência" />
                                <Step title="Concluído" description="Resultado da submissão" />
                            </Steps>
                        </Col>
                        <Col className="issueStepControl" span={8}>
                            <Button.Group>
                                { this.props.step > 0 ? (
                                    <Button type="primary" onClick={this.onStepBackward}>
                                        <Icon type="left" /><span className="hide-small">Anterior</span>
                                    </Button>
                                ) : null }
                                { this.props.step <= 2 ? (
                                    <Button type="primary" onClick={this.onStepForward}>
                                        <span className="hide-small">Seguinte</span><Icon type="right" />
                                    </Button>
                                ) : null }
                            </Button.Group>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }
}

export default PublicForm;



// WEBPACK FOOTER //
// ./src/components/PublicForm.js